import { CommunicationPlatform } from "../../models/communications/communicationPlatform";
import { CommunicationSubject } from "../../models/communications/communicationSubject";

export const sendMessage = async (
    API_URL: string,
    token: string,
    employerId: string,
    employeeIds: string[],
    subject: CommunicationSubject,
    platform: CommunicationPlatform,
    templateId: string,
    employerName: string,
    message: string
) => {
    const response = await fetch(`${API_URL}/communications`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
            employerId,
            employeeIds,
            subject,
            platform,
            emailDetails: {
                templateId,
                parameters: {
                    employer: employerName,
                    message
                }
            }
        })
    }); 

    if(!response.ok) {
        throw new Error("Failed to send message");
    }


}